import { gql } from '@apollo/client'
import { ITagRepository } from 'domain/repositories/Tag'
import { createAuthClient } from './client'
import { Tag, TagInput } from 'domain/entities/Tag'

export class GraphQLTagRepository implements ITagRepository {
  constructor(private getToken: () => Promise<string>) {}
  private client = createAuthClient(
    process.env.REACT_APP_TAGS_GRAPHQL_URL!,
    this.getToken
  )

  async fetchByCampaignId(campaignId: string): Promise<Tag[]> {
    const query = gql`
      query FetchTagsByCampaignId($campaignId: String!) {
        tagsByCampaignId(campaignId: $campaignId) {
          id
          inventoryID
          campaignID
        }
      }
    `

    const { data } = await this.client.query<{ tagsByCampaignId: Tag[] }>({
      query,
      variables: { campaignId },
    })
    return data.tagsByCampaignId
  }

  async fetchByInventoryId(inventoryId: string): Promise<Tag[]> {
    const query = gql`
      query FetchTagsByInventoryId($inventoryId: String!) {
        tagsByInventoryId(inventoryId: $inventoryId) {
          id
          inventoryID
          campaignID
        }
      }
    `

    const { data } = await this.client.query<{ tagsByInventoryId: Tag[] }>({
      query,
      variables: { inventoryId },
    })

    return data.tagsByInventoryId
  }

  async create(tag: TagInput): Promise<void> {
    const MUTATION = gql`
      mutation CreateTag(
        $name: String!
        $inventoryID: String!
        $campaignID: String!
      ) {
        createTag(
          name: $name
          inventoryID: $inventoryID
          campaignID: $campaignID
        ) {
          id
        }
      }
    `
    await this.client.mutate({
      mutation: MUTATION,
      variables: {
        name: tag.name,
        inventoryID: tag.inventoryID,
        campaignID: tag.campaignID,
      },
    })
  }

  async delete(campaignID: string, inventoryID: string): Promise<void> {
    const mutation = gql`
      mutation DeleteTag($campaignID: String!, $inventoryID: String!) {
        deleteTag(campaignID: $campaignID, inventoryID: $inventoryID)
      }
    `
    await this.client.mutate({
      mutation,
      variables: {
        campaignID,
        inventoryID,
      },
    })
  }
}
